"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var translations_1 = tslib_1.__importDefault(require("./translations"));
var UNKNOWN_MESSAGE = 'UNKNOWN_MESSAGE';
var settings = {
    interpolate: /{([\s\S]+?)}/g,
};
var templates = {};
var returnTranslationKey = function (descriptor) {
    if (typeof descriptor === 'string') {
        return descriptor;
    }
    return descriptor.id;
};
var translate = function (descriptor, values) {
    var _a = typeof descriptor === 'object'
        ? descriptor
        : { id: descriptor, defaultMessage: UNKNOWN_MESSAGE }, id = _a.id, defaultMessage = _a.defaultMessage;
    var templateString = translations_1.default.get(id) || defaultMessage;
    templates[templateString] =
        templates[templateString] || lodash_1.template(templateString, settings);
    var templateFn = templates[templateString];
    return templateFn(values);
};
var t = typeof window !== 'undefined' &&
    /showTranslationKeys/.test(window.location)
    ? returnTranslationKey
    : translate;
var i18n = {
    t: t,
};
exports.default = i18n;
//# sourceMappingURL=i18n.js.map